import { MonthYearSpinInput } from '../MonthYearSpinInput'

import {
  MONTH_SPIN_CONTROL_STEP,
  QA_NAME_MONTH_SPIN_NEXT_BTN,
  QA_NAME_MONTH_SPIN_PREV_BTN,
} from './MonthSpinInput.constants'

import * as styles from './MonthSpinInput.module.css'

function MonthSpinInput({
  Component = MonthYearSpinInput,
  className = styles.MonthSpinInput,
  nextActionProps,
  prevActionProps,
  step = MONTH_SPIN_CONTROL_STEP,
  ...componentProps
}) {
  return (
    <Component
      {...componentProps}
      className={className}
      nextActionProps={{
        ...nextActionProps,
        qaName: QA_NAME_MONTH_SPIN_NEXT_BTN,
      }}
      prevActionProps={{
        ...prevActionProps,
        qaName: QA_NAME_MONTH_SPIN_PREV_BTN,
      }}
      step={step}
    />
  )
}

export default MonthSpinInput
